// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as OrderFareDashboardDataMachine from "./OrderFareDashboardDataMachine.bs.js";

function reducer(action, _state) {
  if (action.TAG === /* SetData */0) {
    return {
            TAG: /* Dashboard */0,
            order_fare: action.order_fare,
            order_details: action.order_details
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: action._0
          };
  }
}

function fetchBaseData(order_crn, dispatch, country) {
  return Promise.all([
                  OrderFareDashboardDataMachine.fetchOrderFares(order_crn, country),
                  OrderFareDashboardDataMachine.fetchOrder(order_crn, country)
                ]).then(function (param) {
                var order_details = param[1];
                var order_fare = param[0];
                if (order_fare.TAG === /* Ok */0) {
                  if (order_details.TAG === /* Ok */0) {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: /* SetData */0,
                                    order_fare: order_fare._0,
                                    order_details: order_details._0
                                  }));
                  } else {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: /* SetError */1,
                                    _0: order_details._0
                                  }));
                  }
                } else {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: /* SetError */1,
                                  _0: order_fare._0
                                }));
                }
              }).catch(function (exp) {
              console.log(exp);
              return Promise.resolve(Curry._1(dispatch, {
                              TAG: /* SetError */1,
                              _0: /* DefaultError */{
                                _0: {
                                  title: {
                                    TAG: /* UnprocessedEntity */1,
                                    _0: undefined
                                  },
                                  message: "Unable to decode json object"
                                }
                              }
                            }));
            });
}

export {
  reducer ,
  fetchBaseData ,
  
}
/* OrderFareDashboardDataMachine Not a pure module */
